const homeSections = [
  {
    id: 'recent', // ✅ NEW
    type: 'recent', // 🔥 identify panna use ஆகும்
    header: 'Recently Explored',
    subheader: 'Properties you viewed recently',
    badge_label: 'Recent',
    badge_color: '#2563eb',
  },
  {
    id: 'wishlist',
    type: 'wishlist',
    header: 'Your Wishlist',
    subheader: 'Properties you saved for later — pick up where you left off.',
    badge_label: 'Saved',
    badge_color: '#e11d48',
  },
  {
    id: 'urgent',
    flag: 'is_urgent',
    header: 'Urgent Sales',
    subheader: 'Limited time — act fast before these deals are gone.',
    badge_label: 'Urgent',
    badge_color: '#e53e3e',
  },
  {
    id: 'highlighted',
    flag: 'is_highlighted',
    header: 'Highlighted Properties',
    subheader: 'Handpicked premium listings curated just for you.',
    badge_label: 'Featured',
    badge_color: '#d97706',
  },
  {
    id: 'projects',
    flag: 'is_project',
    header: 'New Projects',
    subheader: 'Explore the latest real estate developments.',
    badge_label: 'Project',
    badge_color: '#2e7d32',
  },
];

export default homeSections;